var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.$t("dashboard.failure_mode_distribution")))]),_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_c('div',{ref:"chartdiv",staticStyle:{"width":"50%","height":"300px"}}),_c('div',{ref:"legendDiv",staticStyle:{"width":"50%","height":"300px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }